/**
 * Pure display component for title blocks.
 * No editing UI. Safe to copy to frontend.
 * plainText=true: render as plain text (no HTML tags), used by 最新消息
 */
export function TitleView({ value, isMobile, mode, plainText, textColor = '#E20020', bold = true, mobilePad = '', mobileSizeClass, desktopSizeClass }) {
    if (!value || value.trim() === '')
        return null;
    const defaultSizeClass = mode === 'mobile' || isMobile ? 'text-4xl'
        : mode === 'tablet' ? 'text-4xl'
            : (desktopSizeClass ?? 'text-5xl');
    const sizeClass = (mode === 'mobile' || isMobile) && mobileSizeClass ? mobileSizeClass : defaultSizeClass;
    const boldClass = bold ? 'font-bold' : '';
    const padClass = (mode === 'mobile' || isMobile) ? mobilePad : '';
    if (plainText) {
        const text = value.replace(/<[^>]+>/g, '').trim();
        return (<div className={`tpl-title-block mb-6 ${boldClass} ${padClass} text-4xl text-left w-full break-words`} style={{ color: textColor }}>{text}</div>);
    }
    return (<div className={`tpl-title-block mb-6 ${boldClass} ${padClass} ${sizeClass}`} style={{ color: textColor }} dangerouslySetInnerHTML={{ __html: value }}/>);
}
